import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// Import your icon images
// import iconTimepointFirst from '@images/new_interface/timepoint/timepoint-first.svg';
// import iconTime from '@images/new_interface/timepoint/clock-circle.svg';
// import iconEndCase from '@images/new_interface/timepoint/icon-end-case.svg';
import AddTimePoint from './AddTimePoint';
import { Icon } from '@components/common'
import EditIcon from '@images/common/edit-action.svg'
// import ModalEditTitle from './ModalEditTitle';
import { ModalUpdateTimePoint } from '../../storyboard/TimePoint';

const WrapTimeLineTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
`

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 16px 0;
  display: flex;
  align-items: center;
`;

const ListItem = styled.li`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 35px;
  background: #fff;
  margin-right: 37px;
  border: ${(props) => (props.active ? '1px solid #0089C2' : '1px solid #D0D5DD')};
  position: relative;
  padding: 10px 16px;
  z-index: 1;
  transition: border-color 0.3s ease;
  .el-edit {
    display: none;
    width: auto;
  }
  &:hover {
    cursor: pointer;
    .el-edit {
      display: block;
    }
  }
  /* Apply :before only to items from the 2nd onward */
  &:nth-child(n + 2):before {
    content: "";
    width: 40px; 
    height: 1px; 
    position: absolute;
    left: -40px;
    top: 50%; 
    background: linear-gradient(to right, transparent 50%, #344054 50%); 
    background-size: 8px 100%;
    z-index: 0;
  }
`;

const ListItemText = styled.span`
  color: ${(props) => (props.active ? '#0089C2' : '#4B5565')};
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.28px;
  white-space: nowrap;
`;

const TimeLineTop = (props) => {
  // props
  const { timelineData: initialTimelineData, timepointIdActive, handleClickTimepoint } = props;

  // state
  const [timelineData, setTimelineData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [timelineDetail, setTimelineDetail] = useState();
  const [modal, setModal] = useState({
    editTitle: false,
  });

  const toggle = (type, timeline) => {
    setModal(prevState => ({ ...prevState, [type]: !prevState[type] }));
    setTimelineDetail(timeline);
  };

  // Effect to set state based on props
  useEffect(() => {
    if (initialTimelineData) {
      const dataWithEndingPage = [
        ...initialTimelineData,
        { Id: 9999, Time: 9999, DisplayName: 'Ending Page', DefaultActiveStatus: false }
      ];
      setTimelineData(dataWithEndingPage);
      const initialActiveIndex = initialTimelineData.findIndex(item => item.Id === timepointIdActive);
      // If timepointIdActive is 9999, set activeIndex to the last item
      if (timepointIdActive === 9999) {
        setActiveIndex(dataWithEndingPage.length - 1);
      } else {
        setActiveIndex(initialActiveIndex !== -1 ? initialActiveIndex : null);
      }
    }
  }, [initialTimelineData, timepointIdActive]);

  return (
    <WrapTimeLineTop>
      <List>
        {timelineData.map((item, index) => (
          <ListItem key={item.Id} active={activeIndex === index} onClick={() => handleClickTimepoint(item)}>
            <ListItemText active={activeIndex === index}>{item.DisplayName}</ListItemText>
            {item?.DisplayName !== "Ending Page" && (
              <div className="el-edit" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggle('editTitle', item)
              }}>
                <Icon src={EditIcon} width={14} height={14} stroke="#1D2939"/>
              </div>
            )}
          </ListItem>
        ))}
      </List>
      <AddTimePoint
        {...props}
      />
      {modal?.editTitle && (
        <ModalUpdateTimePoint 
          isOpen={modal.editTitle}
          toggle={() => toggle("editTitle", null)}
          timepointData={timelineDetail}
        />
      )}
    </WrapTimeLineTop>
  );
};

export default TimeLineTop;